module.exports = __webpack_public_path__ + "static/Abbotsford7-036efa34e26f9d62530f19261f47d153.jpg";